import { render, staticRenderFns } from "./putstoreDetail.vue?vue&type=template&id=251b3fb5&"
import script from "./putstoreDetail.vue?vue&type=script&lang=js&"
export * from "./putstoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports